export const eFormSubmit = {
    bind(el, binding, node) {

        el.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                binding.value();
            }

            return;
        });
    }
};